'use strict';

Object.defineProperty(exports, '__esModule', {
	value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _discountFieldHtml = require('./discount-field.html');

var _discountFieldHtml2 = _interopRequireDefault(_discountFieldHtml);

function DiscountFieldDirective($timeout) {
	'ngInject';

	var directive = {
		link: link,
		template: _discountFieldHtml2['default'],
		'restrict': 'E',
		'transclude': true,
		'scope': {
			'model': '=',
			// The class of the input
			'inputClass': '@inputClass',
			// The class of the label
			'labelClass': '@labelClass',
			// The placeholder of the input
			'labelText': '@labelText',
			// The placeholder of the input
			'myPlaceholder': '@myPlaceholder',
			'inputId': '@inputId'
		}
	};

	return directive;

	function link(scope) {
		var loseFocusTimeout = null;
		scope.onFocusLost = onFocusLost;
		scope.showResults = false;
		scope.value = '';

		scope.$watch(function () {
			var name = '' + scope.model.translation.name;
			var discountValue = ': - ' + scope.model.value + (scope.model.type === 'percent' ? '%' : 'BGN');

			scope.value = name + ' ' + (scope.model.value ? discountValue : '');
		});

		/**
   * Function bind to the blur event on the input.
   * When the input lose focus after a brief timeout the results will be cleared.
   */
		function onFocusLost() {
			$timeout.cancel(loseFocusTimeout);

			loseFocusTimeout = $timeout(function () {
				scope.showResults = false;
			}, 200);
		}
	}
}

exports['default'] = DiscountFieldDirective;
module.exports = exports['default'];


/** WEBPACK FOOTER **
 ** ./client/components/discount-field/discount-field.directive.js
 **/